import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import config from '../config';
import MyMap from './Mapinteraction';
import Logo from './Logo';

const About = () => {
  const { t } = useContext(LanguageContext);
  return (
    <div className="page container">
      <header className="page__head">
        <h1>{t.about.title}</h1>
      </header>

      <div className="about">
        <div className="about__text" data-aos="fade-up">
          <p className="lead">{t.about.p1}</p>
          <p>{t.about.p2}</p>
          <ul className="values-list">
            {t.intro.values.map((v) => (
              <li key={v.title}>
                <strong>{v.title}</strong>
                <span>{v.text}</span>
              </li>
            ))}
          </ul>
          <p className="about__address">
            {t.about.visit} <strong>{config.addressLine}, {config.city}</strong>.
          </p>
          <Logo className="logo--about" alt={config.name} />
        </div>
        <div className="about__map" data-aos="fade-up" data-aos-delay="150">
          <MyMap />
        </div>
      </div>
    </div>
  );
};

export default About;
